let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a3h3m")).then(() => parcelRequire('gWbLK'));